module.exports = __webpack_public_path__ + "static/img/img4.4adcd3e6.png";